import { render } from "./SmGroupProperties.vue?vue&type=template&id=c549d046&scoped=true"
import script from "./SmGroupProperties.vue?vue&type=script&lang=js"
export * from "./SmGroupProperties.vue?vue&type=script&lang=js"

import "./SmGroupProperties.vue?vue&type=style&index=0&id=c549d046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c549d046"]])

export default __exports__